export const supportedLocales = ['zh-CN', 'en-US'];
export function defaultLocaleForRegion(region) {
    return region === 'CN' ? 'zh-CN' : 'en-US';
}
export function isSupportedLocale(value) {
    return value === 'zh-CN' || value === 'en-US';
}
